module.exports = __webpack_public_path__ + "assets/img/avator.cc6ba21a.png";